var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 17h2v-2H6v2zm0 4h2v-2H6v2zm0-8h2v-2H6v2zm-3 8h2v-2H3v2zM23 7H1V4c0-.552.493-1 1.1-1h2.2v1.5c0 .276.246.5.55.5.304 0 .55-.224.55-.5V3h13.2v1.5c0 .276.246.5.55.5.304 0 .55-.224.55-.5V3h2.2c.607 0 1.1.448 1.1 1v3zm0 14.923c0 .595-.493 1.077-1.1 1.077H2.1c-.607 0-1.1-.482-1.1-1.077V9h22v12.923zM21.818 2.182h-2.182V.545a.545.545 0 1 0-1.09 0v1.637H5.454V.545a.545.545 0 1 0-1.091 0v1.637H2.182A2.182 2.182 0 0 0 0 4.364v17.454C0 23.023.977 24 2.182 24h19.636A2.182 2.182 0 0 0 24 21.818V4.364a2.182 2.182 0 0 0-2.182-2.182zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm6 4h2v-2H9v2zm0-8h2v-2H9v2zm0 4h2v-2H9v2zm10 0h2v-2h-2v2zm-3 0h2v-2h-2v2zm3-4h2v-2h-2v2zm-3 0h2v-2h-2v2zm-3 8h2v-2h-2v2zm0-8h2v-2h-2v2zm0 4h2v-2h-2v2z",
    fill: "#3285C2",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.3b27a4ae.svg";
export { ForwardRef as ReactComponent };